import React from "react";
import { IconProps } from "../icon";

export const Link_05Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 17H7A5 5 0 017 7h2m-1 5h10m-2.222 5H17a5 5 0 000-10h-1.222a.778.778 0 00-.778.778v8.444c0 .43.348.778.778.778z"
    />
  </svg>
);
